import { MantineThemeOverride } from '@mantine/core';

export type TransitionTheme = NonNullable<MantineThemeOverride['components']>['Transition'];

export const Transition: TransitionTheme = {
  // todo: define
};
